import React, { useState, useRef } from "react";
import "./sub1.css";
import { Helmet } from "react-helmet";
import emailjs from "@emailjs/browser";
import contactConfig from "../../confi";
export default function DriverServices() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    vehicleType: "",
    serviceType: "",
    serviceDate: "",
    serviceTime: "",
    address: "",
    specialRequirements: "",
  });
  const form = useRef();
  const [loading, setLoading] = useState(false);

  // const handleChange = (e) => {
  //   const { name, value } = e.target;
  //   setFormData(prev => ({
  //     ...prev,
  //     [name]: value
  //   }));
  // };

  const sendEmail = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await emailjs.sendForm(
        "service_v4bj4cq",
        "template_a7bino9",
        form.current,
        "EPURM9NpZ87StWlSC",
      );

      alert("✅ Message sent successfully!");
      e.target.reset();
    } catch (error) {
      console.error("FAILED...", error.text);
      alert("❌ Failed to send message. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    alert(
      "Driver service request submitted successfully! We will contact you soon.",
    );
    // Reset form
    setFormData({
      name: "",
      email: "",
      phone: "",
      vehicleType: "",
      serviceType: "",
      serviceDate: "",
      serviceTime: "",
      address: "",
      specialRequirements: "",
    });
  };

  const serviceFeatures = [
    {
      icon: "🚗",
      text: "Automatic and manual transmission vehicles",
    },
    {
      icon: "🏢",
      text: "Daily office and school drops",
    },
    {
      icon: "🛍️",
      text: "Family outings, shopping trips, and social events",
    },
    {
      icon: "🛣️",
      text: "Long-distance and outstation travel",
    },
    {
      icon: "🌙",
      text: "Night driving with safety and comfort",
    },
    {
      icon: "⭐",
      text: "Luxury and premium vehicle handling",
    },
  ];

  const whyChooseUs = [
    {
      title: "Verified & Licensed Drivers",
      description:
        "Every driver is thoroughly background-checked, license-verified, and reference-approved.",
      icon: "✅",
    },
    {
      title: "Experienced & Well-Trained",
      description:
        "Skilled in city and highway driving, parking, and vehicle handling.",
      icon: "🎓",
    },
    {
      title: "Polite & Presentable",
      description:
        "Drivers are uniformed, courteous, and trained in professional etiquette.",
      icon: "👔",
    },
    {
      title: "Flexible Hiring Options",
      description:
        "Hire a driver for a few hours, full day, or monthly basis — as per your schedule.",
      icon: "⏰",
    },
  ];

  const processSteps = [
    {
      step: "1",
      title: "Share Your Requirement",
      description:
        "Let us know your vehicle type, timing, and route preferences",
    },
    {
      step: "2",
      title: "Get Verified Profiles",
      description:
        "We'll send you details of available, trained drivers in your area",
    },
    {
      step: "3",
      title: "Interview & Select",
      description: "Meet and choose the driver that best fits your requirement",
    },
    {
      step: "4",
      title: "Start Service",
      description:
        "Once confirmed, your driver joins as per your chosen schedule",
    },
    {
      step: "5",
      title: "Ongoing Support",
      description:
        "Our support team stays in touch to ensure quality and satisfaction",
    },
  ];

  const testimonials = [
    {
      name: "Mr. Rajiv Patel",
      location: "Bodakdev, Ahmedabad",
      rating: "⭐⭐⭐⭐⭐",
      text: "I've been using JP Home Services for two years now. My driver is always punctual, polite, and drives safely. Excellent service!",
    },
    {
      name: "Mrs. Rina Desai",
      location: "Surat",
      rating: "⭐⭐⭐⭐⭐",
      text: "The driver provided by JP Home Services is professional and well-mannered. I trust them completely for my daily office travel.",
    },
    {
      name: "Mr. Jignesh Mehta",
      location: "Vadodara",
      rating: "⭐⭐⭐⭐⭐",
      text: "Very reliable and convenient. I hired a driver for my elderly parents in Vadodara, and he's been incredibly patient and caring.",
    },
  ];

  const benefits = [
    "Verified, licensed, and experienced drivers",
    "Punctual and polite professionals",
    "Flexible daily, hourly, or monthly plans",
    "Affordable and transparent pricing",
    "Trusted by hundreds of families and professionals",
    "Dedicated customer support and quick replacements",
    "Available across Ahmedabad, Surat, Vadodara, Rajkot, and Gandhinagar",
  ];

  const cities = [
    "Ahmedabad",
    "Surat",
    "Vadodara",
    "Rajkot",
    "Gandhinagar",
    "Anand",
    "Bhavnagar",
    "Jamnagar",
  ];

  const driverPackages = [
    {
      name: "Part-Time Driver",
      price: "₹6,999",
      period: "/month",
      features: [
        "✓ 4 hours daily service",
        "✓ Local city driving",
        "✓ Office/school drops",
        "✓ Basic vehicle handling",
        "✓ Polite & professional",
        "✗ Night driving",
        "✗ Long distance trips",
      ],
      popular: false,
    },
    {
      name: "Full-Time Driver",
      price: "₹12,999",
      period: "/month",
      features: [
        "✓ 8 hours daily service",
        "✓ City & highway driving",
        "✓ All local travel needs",
        "✓ Professional uniform",
        "✓ Punctual service",
        "✓ Basic night driving",
        "✗ Outstation trips",
      ],
      popular: true,
    },
    {
      name: "Premium Driver Service",
      price: "₹18,999",
      period: "/month",
      features: [
        "✓ 12 hours daily service",
        "✓ Luxury vehicle handling",
        "✓ All travel requirements",
        "✓ Night driving included",
        "✓ Outstation trips",
        "✓ Emergency support",
        "✓ Replacement guarantee",
      ],
      popular: false,
    },
    {
      name: "On-Call Driver",
      price: "₹299",
      period: "/hour",
      features: [
        "✓ Hourly basis service",
        "✓ Flexible timing",
        "✓ Event & party driving",
        "✓ Airport transfers",
        "✓ Emergency rides",
        "✓ Professional conduct",
        "✓ Minimum 4 hours",
      ],
      popular: false,
    },
  ];
  const handleCall = () => {
    window.open(`tel:${contactConfig.phone}`);
  };

  const handleWhatsApp = () => {
    const phoneNumber = `${contactConfig.phone}`;
    const message = "Hello, I would like to know more about your services.";
    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
    window.open(whatsappUrl, "_blank");
  };

  return (
    <div className="main-content-wrapper">
      <Helmet>
        <title>Book Reliable Driver Services in Ahmedabad - JP Home Services</title>
        <meta
          name="description"
          content="Need driver services in Ahmedabad? JP Homes provides an expert, verified & clean background for daily, monthly, or one-time trips. Call +91 9328843812."
        />
        <meta
          name="keywords"
          content="Driver Services Ahmedabad, Personal Driver Ahmedabad, Chauffeur Services Gujarat, On-call Driver Ahmedabad, Full-time Driver Gujarat, Car Driver for Hire, Driver Agency Surat"
        />
        <meta
          name="robots"
          content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1"
        />
        <link
          rel="canonical"
          href="https://jphomeservice.in/driver-services-in-ahmedabad"
        />

        {/* Open Graph */}
        <meta
          property="og:title"
          content="Book Reliable Driver Services in Ahmedabad - JP Home Services"
        />
        <meta
          property="og:description"
          content=" Need driver services in Ahmedabad? JP Homes provides an expert, verified & clean background for daily, monthly, or one-time trips. Call +91 9328843812."
        />
        <meta property="og:type" content="website" />
        <meta
          property="og:url"
          content="https://jphomeservice.in/driver-services-in-ahmedabad"
        />
        <meta
          property="og:image"
          content="https://jphomeservice.in/static/media/Driver1.d00c6faa00f8cb51d0fe.png"
        />

        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:site" content="@" />
        <meta
          name="twitter:title"
          content="Book Reliable Driver Services in Ahmedabad - JP Home Services"
        />
        <meta
          name="twitter:description"
          content="Need driver services in Ahmedabad? JP Homes provides an expert, verified & clean background for daily, monthly, or one-time trips. Call +91 9328843812."
        />
        <meta
          name="twitter:image"
          content="https://jphomeservice.in/static/media/Driver1.d00c6faa00f8cb51d0fe.png"
        />

        {/* JSON-LD */}
        <script type="application/ld+json">
          {`
            {
              "@context": "https://schema.org",
              "@type": "WebPage",
              "@id": "https://jphomeservice.in/driver-services-in-ahmedabad#webpage",
              "url": "https://jphomeservice.in/driver-services-in-ahmedabad",
              "name": "Professional Driver Services in Ahmedabad - JP Home Services",
              "description": "JP Home Services offers trusted driver services in Ahmedabad with verified drivers for full-time, part-time or on-call needs. Call +91 9328843812 today!",
              "inLanguage": "en-IN",
              "isPartOf": {
                "@type": "WebSite",
                "@id": "https://jphomeservice.in/#website",
                "name": "JP Home Services",
                "url": "https://jphomeservice.in/"
              },
              "publisher": {
                "@type": "Organization",
                "@id": "https://jphomeservice.in/#organization",
                "name": "JP Home Services",
                "url": "https://jphomeservice.in/"
              }
            }
          `}
        </script>
        <script type="application/ld+json">
          {`
            {
              "@context": "https://schema.org",
              "@type": "LocalBusiness",
              "name": "Driver Service in Ahmedabad",
              "image": "https://jphomeservice.in/static/media/TRANSPARNT%20LOGO.1a150556bfeacec71cee.png",
              "@id": "",
              "url": "https://jphomeservice.in/driver-services-in-ahmedabad",
              "telephone": "+919327365056",
              "priceRange": "₹₹",
              "address": {
                "@type": "PostalAddress",
                "streetAddress": "A-316-317, Swaminarayan Avenue,  Nr. AEC Cross Road, Naranpura",
                "addressLocality": "Ahmedabad, Gujarat",
                "postalCode": "380013",
                "addressCountry": "IN"
              },
              "geo": {
                "@type": "GeoCoordinates",
                "latitude": 23.0542109,
                "longitude": 72.5482134
              },
              "openingHoursSpecification": {
                "@type": "OpeningHoursSpecification",
                "dayOfWeek": [
                  "Monday",
                  "Tuesday",
                  "Wednesday",
                  "Thursday",
                  "Friday",
                  "Saturday",
                  "Sunday"
                ],
                "opens": "00:00",
                "closes": "23:59"
              },
              "sameAs": [
                "https://www.facebook.com/jphomeservice.in/",
                "https://www.instagram.com/jp_home_service/"
              ] 
            }
          `}
        </script>
        <script type="application/ld+json">
          {`
          {
            "@context": "https://schema.org",
            "@type": "Service",
            "name": "Driver Services in Ahmedabad",
            "serviceType": "Driver Services",
            "description": "JP Home Service provides reliable driver services in Ahmedabad for personal, family, daily travel, and other transportation needs.",
            "url": "https://jphomeservice.in/driver-services-in-ahmedabad",
            "areaServed": {
              "@type": "City",
              "name": "Ahmedabad"
            },
            "provider": {
              "@type": "Organization",
              "name": "JP Home Service",
              "url": "https://jphomeservice.in/"
            }
          }
          `}
        </script>
        <script type="application/ld+json">
          {`
          {
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            "itemListElement": [
              {
                "@type": "ListItem",
                "position": 1,
                "name": "Home",
                "item": "https://jphomeservice.in/"
              },
              {
                "@type": "ListItem",
                "position": 2,
                "name": "Driver Services in Ahmedabad",
                "item": "https://jphomeservice.in/driver-services-in-ahmedabad"
              }
            ]
          }
          `}
        </script>
        <script type="application/ld+json">
          {`
          {
            "@context": "https://schema.org",
            "@graph": [
              {
                "@type": "Review",
                "@id": "https://jphomeservice.in/driver-services-in-ahmedabad#review-rajiv-patel",
                "url": "https://jphomeservice.in/driver-services-in-ahmedabad",
                "itemReviewed": {
                  "@type": "Organization",
                  "name": "JP Home Service",
                  "url": "https://jphomeservice.in/"
                },
                "author": {
                  "@type": "Person",
                  "name": "Mr. Rajiv Patel"
                },
                "reviewRating": {
                  "@type": "Rating",
                  "ratingValue": 5,
                  "bestRating": 5,
                  "worstRating": 1
                },
                "reviewBody": "I've been using JP Home Services for two years now. My driver is always punctual, polite, and drives safely. Excellent service!"
              },
              {
                "@type": "Review",
                "@id": "https://jphomeservice.in/driver-services-in-ahmedabad#review-rina-desai",
                "url": "https://jphomeservice.in/driver-services-in-ahmedabad",
                "itemReviewed": {
                  "@type": "Organization",
                  "name": "JP Home Service",
                  "url": "https://jphomeservice.in/"
                },
                "author": {
                  "@type": "Person",
                  "name": "Mrs. Rina Desai"
                },
                "reviewRating": {
                  "@type": "Rating",
                  "ratingValue": 5,
                  "bestRating": 5,
                  "worstRating": 1
                },
                "reviewBody": "The driver provided by JP Home Services is professional and well-mannered. I trust them completely for my daily office travel."
              },
              {
                "@type": "Review",
                "@id": "https://jphomeservice.in/driver-services-in-ahmedabad#review-jignesh-mehta",
                "url": "https://jphomeservice.in/driver-services-in-ahmedabad",
                "itemReviewed": {
                  "@type": "Organization",
                  "name": "JP Home Service",
                  "url": "https://jphomeservice.in/"
                },
                "author": {
                  "@type": "Person",
                  "name": "Mr. Jignesh Mehta"
                },
                "reviewRating": {
                  "@type": "Rating",
                  "ratingValue": 5,
                  "bestRating": 5,
                  "worstRating": 1
                },
                "reviewBody": "Very reliable and convenient. I hired a driver for my elderly parents in Vadodara, and he's been incredibly patient and caring."
              },
              {
                "@type": "AggregateRating",
                "@id": "https://jphomeservice.in/driver-services-in-ahmedabad#aggregate-rating",
                "itemReviewed": {
                  "@type": "Organization",
                  "name": "JP Home Service",
                  "url": "https://jphomeservice.in/"
                },
                "ratingValue": 5,
                "bestRating": 5,
                "worstRating": 1,
                "reviewCount": 3
              }
            ]
          }
          `}
        </script>
      </Helmet>
      <div className="driver-services-container">
        {/* Hero Section */}
        <section className="driver-hero-section">
          <div className="container">
            <div className="driver-hero-content">
              <h1>
                Driver Services in Ahmedabad, Surat & Major Cities of Gujarat
              </h1>
              <p className="hero-subtitle">
                <strong>
                  Professional, Punctual & Polite Drivers for Your Daily Comfort
                  and Safety
                </strong>
              </p>
              <p className="hero-description">
                Managing your busy lifestyle often means you need a reliable
                person behind the wheel — someone you can trust with your time,
                your car, and your safety. At JP Home Services, we provide
                experienced, background-verified drivers in Ahmedabad, Surat,
                Vadodara, Rajkot, and across Gujarat, ensuring you enjoy
                stress-free, comfortable, and punctual travel every day.
              </p>
              <p className="hero-description">
                Whether you need a full-time personal driver, part-time
                chauffeur, or an on-call driver for business or family trips,
                our team ensures complete professionalism and peace of mind.
              </p>
              <div className="hero-stats">
                <div className="stat-item">
                  <span className="stat-number">500+</span>
                  <p className="stat-label">Happy Clients</p>
                </div>
                <div className="stat-item">
                  <span className="stat-number">100%</span>
                  <p className="stat-label">Verified Drivers</p>
                </div>
                <div className="stat-item">
                  <span className="stat-number">24/7</span>
                  <p className="stat-label">Support</p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <div className="floating-contact-icons">
          <div className="contact-icon whatsapp-icon" onClick={handleWhatsApp}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
              <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893c0-3.18-1.24-6.169-3.495-8.424" />
            </svg>
          </div>
          <div className="contact-icon call-icon" onClick={handleCall}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
              <path d="M20 10.999h2C22 5.869 18.127 2 12.99 2v2C17.052 4 20 6.943 20 10.999z" />
              <path d="M13 8c2.103 0 3 .897 3 3h2c0-3.225-1.775-5-5-5v2zm3.422 5.443a1.001 1.001 0 00-1.391.043l-2.393 2.461c-.576-.11-1.734-.471-2.926-1.66-1.192-1.193-1.553-2.354-1.66-2.926l2.459-2.394a1 1 0 00.043-1.391L6.859 3.513a1 1 0 00-1.391-.087l-2.17 1.861a1 1 0 00-.29.649c-.015.25-.301 6.172 4.291 10.766C11.305 20.707 16.323 21 17.705 21c.202 0 .326-.006.359-.008a.992.992 0 00.648-.291l1.86-2.171a1 1 0 00-.086-1.391l-4.064-3.696z" />
            </svg>
          </div>
        </div>

        {/* Service Features Section */}
        <section className="service-features-section">
          <div className="container">
            <div className="section-header1">
              <h2>Our Driver Service Features</h2>
              <p>
                Our professional drivers are carefully selected for driving
                skill, discipline, and reliability, making them ideal for both
                family and corporate requirements.
              </p>
            </div>

            <div className="features-grid">
              {serviceFeatures.map((feature, index) => (
                <div key={index} className="feature-item">
                  <div className="feature-icon1">{feature.icon}</div>
                  <span>{feature.text}</span>
                </div>
              ))}
            </div>

            <div className="flexibility-note">
              <p>
                <strong>
                  From city commutes to weekend getaways — our drivers make
                  every journey smooth and stress-free.
                </strong>
              </p>
            </div>
          </div>
        </section>

        {/* Pricing Packages Section */}
        {/* <section className="pricing-packages-section">
          <div className="container">
            <div className="section-header1">
              <h2>Driver Service Packages</h2>
              <p>Flexible and affordable driver service packages designed for different needs</p>
            </div>

            <div className="packages-grid">
              {driverPackages.map((pkg, index) => (
                <div key={index} className={`package-card ${pkg.popular ? 'popular' : ''}`}>
                  {pkg.popular && <div className="popular-badge">Most Popular</div>}
                  <h3>{pkg.name}</h3>
                  <div className="package-price">
                    {pkg.price}<span>{pkg.period}</span>
                  </div>
                  <ul className="package-features">
                    {pkg.features.map((feature, idx) => (
                      <li key={idx} className={feature.startsWith('✗') ? 'not-included' : ''}>
                        {feature}
                      </li>
                    ))}
                  </ul>
                  <button className="package-btn">
                    Select Package
                  </button>
                </div>
              ))}
            </div>
          </div>
        </section> */}

        {/* Why Choose Us Section */}
        <section className="why-choose-section">
          <div className="container">
            <div className="section-header1">
              <h2>Why Choose Drivers from JP Home Services</h2>
              <p>
                We understand that hiring a driver is not just about convenience
                — it's about trust, safety, and professionalism. Here's why
                families and professionals across Gujarat prefer JP Home
                Services:
              </p>
            </div>

            <div className="features-grid">
              {whyChooseUs.map((feature, index) => (
                <div key={index} className="feature-card">
                  <div className="feature-icon1">{feature.icon}</div>
                  <h3>{feature.title}</h3>
                  <p>{feature.description}</p>
                </div>
              ))}
            </div>

            <div className="additional-benefits">
              <div className="benefit-item">
                <span className="check-icon">✓</span>
                <span>
                  Punctuality Guaranteed - Our drivers value your time and
                  maintain on-time performance every day
                </span>
              </div>
              <div className="benefit-item">
                <span className="check-icon">✓</span>
                <span>
                  Replacement & Support - Immediate replacement provided if you
                  wish to switch drivers — ensuring zero downtime
                </span>
              </div>
            </div>

            <div className="trust-note">
              <p>
                <strong>
                  Professional service. Personal care. Reliable every mile.
                </strong>
              </p>
            </div>
          </div>
        </section>

        {/* How It Works Section */}
        <section className="process-section">
          <div className="container">
            <div className="section-header1">
              <h2>How Our Driver Service Works</h2>
              <p>
                Our process is simple, secure, and transparent — built for your
                convenience.
              </p>
            </div>

            <div className="process-steps">
              {processSteps.map((step, index) => (
                <div key={index} className="process-step">
                  <div className="step-number">{step.step}</div>
                  <div className="step-content">
                    <h3>{step.title}</h3>
                    <p>{step.description}</p>
                  </div>
                </div>
              ))}
            </div>

            <div className="process-conclusion">
              <p>
                <strong>From request to ride — we make it effortless.</strong>
              </p>
            </div>
          </div>
        </section>

        {/* Booking Form Section */}
        <section className="booking-section">
          <div className="container">
            <div className="booking-content">
              <div className="booking-info">
                <h2>Book Driver Service</h2>
                <p>
                  Fill out the form and we'll match you with the perfect driver
                  for your needs.
                </p>

                <div className="service-highlights">
                  <div className="highlight-item">
                    <span className="highlight-icon">✅</span>
                    <span>Background verified and licensed drivers</span>
                  </div>
                  <div className="highlight-item">
                    <span className="highlight-icon">✅</span>
                    <span>Experienced in city and highway driving</span>
                  </div>
                  <div className="highlight-item">
                    <span className="highlight-icon">✅</span>
                    <span>Polite, uniformed, and professional</span>
                  </div>
                  <div className="highlight-item">
                    <span className="highlight-icon">✅</span>
                    <span>Flexible timing options</span>
                  </div>
                </div>

                <div className="contact-info">
                  <h3>Need Immediate Driver?</h3>
                  <p>
                    Call us: <strong>{contactConfig.phone}</strong>
                  </p>
                  <p>
                    Email: <strong>{contactConfig.email}</strong>
                  </p>
                </div>
              </div>
              <div className="booking-form-container">
                <form className="contact-form" ref={form} onSubmit={sendEmail}>
                  <div className="form-group123">
                    <h3>Request Driver Service</h3>
                  </div>
                  {/* <div className="form-group">
                      <label htmlFor="location">Maid in Ahmedabad</label>
                    </div> */}

                  <div className="form-group">
                    <input
                      type="text"
                      id="name"
                      name="name"
                      placeholder="Your Name*"
                      required
                    />
                  </div>

                  <div className="form-group">
                    <input
                      type="email"
                      id="email"
                      name="emailid"
                      placeholder="Email Address*"
                      required
                    />
                  </div>

                  <div className="form-group">
                    <input
                      type="tel"
                      id="phone"
                      name="contactno"
                      placeholder="Phone Number*"
                      required
                    />
                  </div>

                  <div className="form-row">
                    <div className="form-group">
                      <select id="category" required name="ServiceRequired">
                        <option value="">Choose a category</option>
                        <option value="House Maid">House Maid</option>
                        <option value="Baby Sitting">Baby Sitting</option>
                        <option value="Elderly Care">Elderly Care</option>
                        <option value="Patient Care">Patient Care</option>
                        <option value="Cook">Cook</option>
                        <option value="Driver">Driver</option>
                        <option value="Full Time Servant">24x7 Servant</option>
                        <option value="Office Boy">Office Boy</option>
                        <option value="Pet Care">Pet Care</option>
                      </select>
                    </div>
                  </div>

                  {/* <div className="form-group">
                      <textarea
                        id="message"
                        placeholder="Your Message*"
                        rows="5"
                        name="user_message"
                        required
                      ></textarea>
                    </div> */}

                  <button
                    type="submit"
                    className="submit-btn1"
                    disabled={loading}
                    onClick={() => {
                      return window.gtag_report_conversion
                        ? window.gtag_report_conversion(
                          "https://jphomeservice.in/",
                        )
                        : true;
                    }}
                  >
                    {loading ? "Sending..." : "Send Message"}
                  </button>
                </form>
              </div>
            </div>
          </div>
        </section>

        {/* Testimonials Section */}
        <section className="testimonials-section">
          <div className="container2">
            <h2>What Our Clients Say</h2>
            <div className="testimonials-grid">
              {testimonials.map((testimonial, index) => (
                <div key={index} className="testimonial-card">
                  <div className="testimonial-rating">{testimonial.rating}</div>
                  <p className="testimonial-text">"{testimonial.text}"</p>
                  <div className="testimonial-author">
                    <strong>{testimonial.name}</strong>
                    <span>{testimonial.location}</span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Benefits Section */}
        <section className="benefits-section">
          <div className="container">
            <div className="section-header1">
              <h2>Benefits of Choosing JP Home Services for Driver Services</h2>
              <p>
                Choosing JP Home Services means enjoying comfort, safety, and
                professionalism in every drive.
              </p>
            </div>

            <div className="benefits-grid">
              {benefits.map((benefit, index) => (
                <div key={index} className="benefit-item-large">
                  <span className="check-icon">✓</span>
                  <span>{benefit}</span>
                </div>
              ))}
            </div>

            <div className="brand-tagline">
              <p>
                <strong>
                  Because your time, safety, and comfort matter most.
                </strong>
              </p>
            </div>
          </div>
        </section>

        {/* Service Coverage Section */}
        <section className="coverage-section">
          <div className="container">
            <div className="section-header1">
              <h2>Service Coverage</h2>
              <p>
                We offer driver services across all major cities of Gujarat:
              </p>
            </div>

            <div className="cities-grid">
              {cities.map((city, index) => (
                <div key={index} className="city-item">
                  {city}
                </div>
              ))}
            </div>

            <div className="coverage-note">
              <p>
                <strong>
                  Whether you need a personal chauffeur, corporate driver, or
                  on-call professional, JP Home Services is your trusted driving
                  partner.
                </strong>
              </p>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
}
